module.exports = __webpack_public_path__ + "static/media/vod25.4ca0248d.png";